import { IStyle } from "@fluentui/react";
import { CSSProperties } from "react";

export const CUSTOM_PARTNER_LIST_STYLES = {
  customDataGridColumns: {
    idContainer: {
      alignItems: "center"
    } as IStyle,
    idTooltipCopyIconBtn: { fontSize: 12 } as CSSProperties,
    idTooltipContainerBtn: {
      color: "#000 !important",
      height: 22,
      marginLeft: "2px !important"
    } as unknown as IStyle,
    iconStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%"
    }
  }
};
